import { connect } from 'react-redux';
import type { Dispatch } from '@reduxjs/toolkit';

import type {
  DispatchProps,
  OwnProps,
} from 'src/components/organisms/Personalisation/components/SelectionSingleOrBinary';
import { SelectionSingleOrBinary } from 'src/components/organisms/Personalisation/components/SelectionSingleOrBinary';
import {
  selectNumberOfRequiredOptions,
  selectOptions,
  selectOutstandingOptions,
  selectSelectedOption,
  selectTrackedEvents,
} from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import type {
  InteractionErrorTrackingEvent,
  InteractionTrackingEvent,
  ProgressTrackingEvent,
  SelectionPayload,
} from 'src/redux/basket/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

const mapStateToProps = (state: ReduxApplicationState, props: OwnProps) => ({
  currency: state.product.price.currency,
  error:
    Boolean(props.displayValidation) &&
    selectOutstandingOptions(state).some((opt) => opt.id === props.id),
  options: selectOptions(state),
  outstandingSelections: selectOutstandingOptions(state),
  selectedOption: selectSelectedOption(state, props.id),
  totalOutstandingSelections: selectOutstandingOptions(state).length,
  totalRequiredOptions: selectNumberOfRequiredOptions(state),
  trackedEvents: selectTrackedEvents(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  trackInteraction: (payload: InteractionTrackingEvent) =>
    dispatch(basketActions.trackInteraction(payload)),
  trackProgressMilestone: (payload: ProgressTrackingEvent) =>
    dispatch(basketActions.trackProgressMilestone(payload)),
  trackInteractionError: (payload: InteractionErrorTrackingEvent) =>
    dispatch(basketActions.trackInteractionError(payload)),
  toggleSelectOption: (payload: SelectionPayload) =>
    dispatch(basketActions.toggleSelectOption(payload)),
});

export const SelectionSingleOrBinaryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectionSingleOrBinary);
